import { configureStore } from '@reduxjs/toolkit';
import loaderSlice from './loader';
import calendarSlice from './calendar';
import appointmentSlice from './appointment';
import doctorSchedulerSlice from './doctor-scheduler';
import backgroundDataSlice from './MedicalRecord/backgroundData';
import consultationReasonsSlice from './MedicalRecord/consultationReasons';
import currentProblemSlice from './MedicalRecord/currentProblem';
import diagnosticSlice from './MedicalRecord/diagnostic';
import organSystemReviewSlice from './MedicalRecord/organSystemReview';
import physicalExamSlice from './MedicalRecord/physicalExamn';
import preparationSlice from './MedicalRecord/preparation';
import treatmentSlice from './MedicalRecord/treatment';

const store = configureStore({
  reducer: {
    loader: loaderSlice,
    calendar: calendarSlice,
    appointment: appointmentSlice,
    doctorScheduler: doctorSchedulerSlice,
    backgroundData: backgroundDataSlice,
    consultationReasons: consultationReasonsSlice,
    currentProblem: currentProblemSlice,
    diagnostic: diagnosticSlice,
    organSystemReview: organSystemReviewSlice,
    physicalExam: physicalExamSlice,
    preparation: preparationSlice,
    treatment: treatmentSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
